import React from 'react';
import './Preview.css';

const Preview = ({ formData, language = 'fr' }) => {
  const { 
    name, address, email, phone, linkedin, github, portfolio, photo, summary, 
    education, experience, projects, skills, languages, certifications 
  } = formData;

  const hasLink = (url) => url && url.trim() !== '';

  return (
    <div className="preview-container">
      <div className="cv-page">
        {/* HEADER - IDENTIQUE AU PDF */}
        <div className="cv-header">
          {photo && (
            <div className="cv-photo">
              <img src={photo} alt="Photo" />
            </div>
          )}
          <div className="header-content">
            <h1 className="cv-name">{name || 'Votre Nom'}</h1>
            {(address || email || phone) && (
              <p className="cv-contact">
                {address && `${address}`}
                {email && ` | ${email}`}
                {phone && ` | ${phone}`}
              </p>
            )}
            {(linkedin || github || portfolio) && (
              <div className="cv-links">
                {hasLink(linkedin) && <a href={`https://${linkedin}`} className="cv-link">LinkedIn</a>}
                {hasLink(github) && <a href={`https://${github}`} className="cv-link">GitHub</a>}
                {hasLink(portfolio) && <a href={`https://${portfolio}`} className="cv-link">Portfolio</a>}
              </div>
            )}
          </div>
        </div>

        {/* PROFIL */}
        {summary && (
          <section className="cv-section">
            <h3 className="section-title">Profil</h3>
            <p className="section-text">{summary}</p>
          </section>
        )}

        {/* FORMATION */}
        {education.length > 0 && (
          <section className="cv-section">
            <h3 className="section-title">Formation</h3>
            {education.map((edu, i) => (
              <div key={i} className="cv-item">
                <div className="item-header">
                  <strong>{edu.school}</strong>
                  <span className="item-date">{edu.start} - {edu.end}</span>
                </div>
                <div className="item-subtitle">{edu.degree}</div>
              </div>
            ))}
          </section>
        )}

        {/* EXPÉRIENCE */}
        {experience.length > 0 && (
          <section className="cv-section">
            <h3 className="section-title">Expérience Professionnelle</h3>
            {experience.map((exp, i) => (
              <div key={i} className="cv-item">
                <div className="item-header">
                  <strong>{exp.role}</strong>
                  <span className="item-date">{exp.start} - {exp.end}</span>
                </div>
                <div className="item-subtitle">{exp.company} - {exp.location}</div>
                {exp.description.split('\n').map((line, j) => line.trim() && (
                  <p key={j} className="bullet">• {line.trim()}</p>
                ))}
              </div>
            ))}
          </section>
        )}

        {/* DEUX COLONNES */}
        <div className="cv-two-columns">
          <div className="left-column">
            {projects.length > 0 && (
              <section className="cv-section">
                <h3 className="section-title">Projets Académiques</h3>
                {projects.map((proj, i) => (
                  <div key={i} className="cv-item">
                    <div className="item-header">
                      <strong>{proj.name}</strong>
                      <span className="item-date">{proj.date}</span>
                    </div>
                    <div className="item-subtitle">Technologies: {proj.technologies}</div>
                    {proj.description.split('\n').map((line, j) => line.trim() && (
                      <p key={j} className="bullet">• {line.trim()}</p>
                    ))}
                  </div>
                ))}
              </section>
            )}

            {Object.values(skills).flat().filter(s => s.trim()).length > 0 && (
              <section className="cv-section">
                <h3 className="section-title">Compétences Techniques</h3>
                {Object.entries(skills).map(([cat, list]) => 
                  list.filter(s => s.trim()).length > 0 && (
                    <div key={cat} className="skill-category">
                      <strong>• {
                        cat === "programming" ? "Langages de programmation" :
                        cat === "frameworks" ? "Frameworks & Bibliothèques" :
                        cat === "databases" ? "Bases de données" :
                        cat === "tools" ? "Gestion de projet" :
                        cat === "dataAnalysis" ? "Analyse de données" : cat
                      }:</strong>
                      <span className="skill-list">{list.filter(s => s.trim()).join(', ')}</span>
                    </div>
                  )
                )}
              </section>
            )}
          </div>

          <div className="right-column">
            {languages.length > 0 && (
              <section className="cv-section">
                <h3 className="section-title">Langues</h3>
                {languages.map((lang, i) => (
                  <div key={i} className="lang-item">
                    <span>• {lang.language}</span>
                    <span>{lang.level}</span>
                  </div>
                ))}
              </section>
            )}

            {certifications.length > 0 && (
              <section className="cv-section">
                <h3 className="section-title">Certifications</h3>
                {certifications.map((cert, i) => (
                  <div key={i} className="cert-item">
                    <div className="item-subtitle">• {cert.name}</div>
                    <div className="item-detail">{cert.issuer} - {cert.date}</div>
                  </div>
                ))}
              </section>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preview;